module.exports = __webpack_public_path__ + "static/media/arcyptera_fusca.7dd8da04.jpg";